import React, { useEffect, useState } from "react";
import { Save, ChevronUp, ChevronDown } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { PageHeader, Loader } from "@/components/dashboard/ui";

export default function AdminPages() {
  const [pages, setPages] = useState(null);
  useEffect(() => { api.get("/website/pages").then(({ data }) => setPages(data || [])); }, []);
  const upd = (i, field, val) => setPages((p) => p.map((x, idx) => idx === i ? { ...x, [field]: val } : x));
  const move = (i, dir) => setPages((p) => {
    const j = i + dir; if (j < 0 || j >= p.length) return p;
    const a = [...p]; [a[i], a[j]] = [a[j], a[i]]; return a.map((x, idx) => ({ ...x, order: idx }));
  });
  const save = async () => { await api.put("/website/pages", { pages: pages.map((p, i) => ({ ...p, order: i })) }); toast.success("Pages enregistrées"); };
  if (pages === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Pages du site" subtitle="Activez, masquez, renommez et réordonnez les pages publiques."
        action={<Button className="bg-primary" onClick={save} data-testid="pages-save"><Save className="h-4 w-4 mr-1.5" />Enregistrer</Button>} />
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="hidden md:grid grid-cols-12 gap-2 px-4 py-2.5 bg-slate-50 text-xs font-semibold text-slate-500 uppercase">
          <div className="col-span-1">Ordre</div><div className="col-span-3">Titre menu</div><div className="col-span-3">URL</div>
          <div className="col-span-1 text-center">Active</div><div className="col-span-2 text-center">Menu</div><div className="col-span-2 text-center">Pied de page</div>
        </div>
        {pages.map((p, i) => (
          <div key={p.slug} className="grid grid-cols-2 md:grid-cols-12 gap-2 items-center px-4 py-3 border-t border-slate-100" data-testid={`page-row-${p.slug}`}>
            <div className="col-span-1 flex md:flex-col gap-1">
              <button onClick={() => move(i, -1)} className="text-slate-300 hover:text-slate-700"><ChevronUp className="h-4 w-4" /></button>
              <button onClick={() => move(i, 1)} className="text-slate-300 hover:text-slate-700"><ChevronDown className="h-4 w-4" /></button>
            </div>
            <div className="col-span-1 md:col-span-3"><Input value={p.menu_title} onChange={(e) => upd(i, "menu_title", e.target.value)} className="h-9" /></div>
            <div className="col-span-2 md:col-span-3"><Input value={p.slug} disabled={p.locked} onChange={(e) => upd(i, "slug", e.target.value)} className="h-9 text-slate-500" /></div>
            <div className="col-span-2 md:col-span-1 flex justify-center"><Switch checked={p.active !== false} disabled={p.locked} onCheckedChange={(v) => upd(i, "active", v)} data-testid={`page-active-${p.slug}`} /></div>
            <div className="col-span-1 md:col-span-2 flex justify-center"><Switch checked={p.nav_visible !== false} onCheckedChange={(v) => upd(i, "nav_visible", v)} data-testid={`page-nav-${p.slug}`} /></div>
            <div className="col-span-1 md:col-span-2 flex justify-center"><Switch checked={p.footer_visible !== false} onCheckedChange={(v) => upd(i, "footer_visible", v)} data-testid={`page-footer-${p.slug}`} /></div>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-500">Une page désactivée disparaît du menu, du menu mobile et n'est plus accessible publiquement. L'accueil est verrouillé.</p>
    </div>
  );
}
